var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex w-100"
  }, [_c('b-form', {
    staticClass: "w-50",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "spnod-admin__account--section"
  }, [_c('h5', {
    staticClass: "spnod-admin__account--header"
  }, [_vm._v("Personal Details")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("First Name:")]), _vm._v(" " + _vm._s(_vm.user.firstName))]), _vm._v(" "), _c('b-col', {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Last Name:")]), _vm._v(" " + _vm._s(_vm.user.lastName))])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Phone:")]), _vm._v(" " + _vm._s(_vm.user.phone))]), _vm._v(" "), _c('b-col', {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Email:")]), _vm._v(" " + _vm._s(_vm.user.email))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "spnod-admin__account--section"
  }, [_c('h5', {
    staticClass: "spnod-admin__account--header"
  }, [_vm._v("Groups")]), _vm._v(" "), _c('UserAccountGroupForm', {
    attrs: {
      "activeGroups": _vm.newGroups,
      "groups": _vm.groups.data
    },
    on: {
      "handleAdd": _vm.handleGroupAdd,
      "handleRemove": _vm.handleGroupRemove
    }
  })], 1), _vm._v(" "), _c('div', [_c('b-button', {
    staticClass: "spnod-admin__form--button",
    attrs: {
      "size": "sm"
    },
    on: {
      "click": _vm.handleSave
    }
  }, [(!_vm.isSending) ? _c('p', [_vm._v("Save")]) : _c('span', {
    staticClass: "spinner-border spinner-border-sm",
    attrs: {
      "role": "status",
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('b-button', {
    staticClass: "bg-danger",
    attrs: {
      "size": "sm"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('handleCancel')
      }
    }
  }, [_vm._v("Cancel")])], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af0d20c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/UserAccount/UserAccountForm.vue
// module id = yMwJ
// module chunks = 2